import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/students',
    name: 'students',
    component: () => import('../views/List/Students.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/teachers',
    name: 'teachers',
    component: () => import('../views/List/Teachers.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/admins',
    name: 'admins',
    component: () => import('../views/List/Admins.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/courses',
    name: 'courses',
    component: () => import('../views/List/Courses.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/sells',
    name: 'sells',
    component: () => import('../views/List/Sells.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/doubts',
    name: 'doubts',
    component: () => import('../views/List/Doubts.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/tickets',
    name: 'tickets',
    component: () => import('../views/List/Tickets.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/sell-log',
    name: 'sell-log',
    component: () => import('../views/List/SellLog.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Auth/Login.vue'),
  },

  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/Auth/Logout.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '*',
    name: 'error',
    component: () => import('../views/Error/404.vue'),
    meta: { requiresAuth: true }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('ak-adm-token')) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
export default router
